import Vue from "vue";
import { ls } from "./cache.js";
// import store from '@/store'
import { USERINFO } from "@/store/mutation-types";

!Vue.prototype.$auth &&
  Object.defineProperties(Vue.prototype, {
    $auth: {
      get() {
        return permissions => {
          const user = ls.get(USERINFO);
          if (user && user.Permissions && user.Permissions.length) {
            const index = user.Permissions.indexOf(permissions);
            if (index > -1) {
              return true;
            }
            return false;
          }
        };
      },
    },
  });
